import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getTrackLengthwithracecourseSlice = createSlice({
    name: 'tracklengthwithracecourse',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchTrackLengthwithRaceCourse.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchTrackLengthwithRaceCourse.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchTrackLengthwithRaceCourse.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setColor, setStatus } = getTrackLengthwithracecourseSlice.actions;
export default getTrackLengthwithracecourseSlice.reducer;

export const fetchTrackLengthwithRaceCourse = createAsyncThunk('/TrackLengthDropDownForSpecificRaceCourse/fetch', async ({ racecourseid }) => {
    const res = await axios.get(`${window.env.API_URL}/TrackLengthDropDownForSpecificRaceCourse/${racecourseid}`);
    const racecourseDatawithtracklength = res.data;
    return racecourseDatawithtracklength.data;
})